import { render, staticRenderFns } from "./KBSimpleTable.vue?vue&type=template&id=bb92bf3a&"
import script from "./KBSimpleTable.vue?vue&type=script&lang=js&"
export * from "./KBSimpleTable.vue?vue&type=script&lang=js&"
import style0 from "./KBSimpleTable.vue?vue&type=style&index=0&id=bb92bf3a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports